import axios from "axios";
import { ValidationItemProps } from "./ValidationItemProps";
import { validationBacklogUrls } from "../../../URL/ApplicationUrls";

export default async (item: ValidationItemProps) => {
  const response = await axios.post(validationBacklogUrls.pdsrs.apiUrl, item);
  return response.data;
};
